import axios from '../../axios'

/*
 * 授权小程序数据接口
 */
// 获取抖音号绑定列表
export const getMountList = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope/page',
        method: 'get',
        data
    })
}

// 抖音号绑定id查询
export const getMountId = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope/get',
        method: 'get',
        data
    })
}

// 新增抖音号绑定信息
export const addMount = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope',
        method: 'post',
        data
    })
}

// 编辑抖音号绑定信息
export const updateMount = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope',
        method: 'put',
        data
    })
}

// 抖音号绑定
export const bindTiktokMount = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope/submit',
        method: 'post',
        data
    })
}

// 抖音号解除绑定
export const unbindTiktokMount = (data) => {
    return axios({
        url: '/api/course/tiktok/mount/scope/unbind/account',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/mount.js